module.exports = __webpack_public_path__ + "img/avatar.3fc8d0a5.svg";